import * as Sentry from '@sentry/react';

export function captureException(error: Error | unknown, response?: unknown) {
  // eslint-disable-next-line no-console
  if (response) console.warn(response);
  Sentry.captureException(error);
}
